webpackJsonp([53569954864128],{

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 1000px;\n  h2 + p {\n    margin-bottom: 2.5rem;\n    text-align: center;\n  }\n'], ['\n  max-width: 1000px;\n  h2 + p {\n    margin-bottom: 2.5rem;\n    text-align: center;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Section = _styledComponents2.default.section(_templateObject);
	
	var SchedulePage = function SchedulePage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    Section,
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Schedule'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Schedule subject to change'
	    ),
	    _react2.default.createElement(
	      'table',
	      null,
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'Time'
	          ),
	          _react2.default.createElement(
	            'th',
	            null,
	            'Talk'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        data.allScheduleCsv.edges.map(function (_ref2, i) {
	          var node = _ref2.node;
	          return _react2.default.createElement(
	            'tr',
	            { key: i },
	            _react2.default.createElement(
	              'td',
	              null,
	              node.from,
	              '\u2013',
	              node.to
	            ),
	            node.slug ? _react2.default.createElement(
	              'td',
	              null,
	              _react2.default.createElement(
	                'h3',
	                null,
	                node.session
	              ),
	              'By ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/speakers#' + node.slug },
	                node.speaker
	              )
	            ) : _react2.default.createElement(
	              'td',
	              null,
	              node.session
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = SchedulePage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-schedule-js-36d05e5e9463215d0082.js